import { createContext } from 'react'

/**
 * True while the host shows something over the conversation that makes its
 * web app cards pointless to keep running — the story board editor, which
 * hides the session page with display: none but leaves it mounted. A paused
 * card draws a placeholder of the same height instead of its iframe, so the
 * page underneath does not keep a second copy of the story board loaded, and
 * the card loads afresh (with any edits) when the editor closes.
 */
export const WebappFramesPausedContext = createContext(false)
